
import React from 'react';
import PropTypes from 'prop-types';
import t from './utils/i18n.js';

let filterActive = false;

class SortFilter extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            active: false,
            selected: [],
            type: 'random'
        };
    }
    render() {

        this.handleClick = this.toggleFilter.bind(this);
        this.handleHide = this.hideFilter.bind(this);
        this.setSort = this.setSort.bind(this);
        this.setRandom = this.setRandom.bind(this);

        const applyFilter = () => {
            this.setState({
                active: false
            });
        };

        return (
            <div className="filter__wrapper">
                <button className={ 'filter__toggle filter__toggle--' + this.props.type + (this.state.active ? ' filter__toggle--active' : '')} onClick={this.handleClick}>{ t("Sortering", this.props.lang) }</button>
                <div className={ 'filter__container filter__container--order' + (this.state.active ? ' filter__container--active' : '') }>
                    <div className={ 'filter filter--order' + (this.state.active ? ' filter__active' : '') }>
                        <strong>{t('Sorteringsrekkefølge', this.props.lang)}:</strong><br />
                        <div className="filter__options">
                            <div className="filter__type">
                                <div><label className="radio radio--small"><input type="radio" name="ordering" value="random" checked={this.state.type === 'random'} onChange={this.setRandom} /><i className="radio__indicator"></i>{t("Tilfeldig", this.props.lang)}</label></div>
                            </div>
                            <div className="filter__type">
                                <div><label className="radio radio--small"><input type="radio" name="ordering" value="a-z" checked={this.state.type === 'a-z'} onChange={this.setSort} /><i className="radio__indicator"></i>{t("Alfabetisk", this.props.lang)}</label></div>
                            </div>
                        </div>
                        {/*
                        <div className="filter__action">
                            <button className="filter__apply" onClick={applyFilter}>{t("Vis", this.props.lang)}</button>
                        </div>
                        */}
                    </div>
                </div>
            </div>
        );
    }
    toggleFilter() {
        let active = !this.state.active;
        this.setState({
            active: !this.state.active
        });
    }
    hideFilter() {
        this.setState({
            active: false
        });
    }
    setRandom() {
        this.setOrdering(true);
    }
    setSort() {
        this.setOrdering(false);
    }
    setOrdering(random) {
        if (random) {
            this.setState({
                'type' : 'random'
            });
            this.props.shuffle();
        } else {
            this.setState({
                'type' : 'a-z'
            });
            this.props.unShuffle();
        }
    }
};

SortFilter.propTypes = {
    shuffle: PropTypes.func,
    unShuffle: PropTypes.func,
    lang: PropTypes.string,
};

export default SortFilter;
